import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardSection from 'UIComponents/card/UICardSection';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UICardWrapper from 'UIComponents/card/UICardWrapper'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message

import { ProductLinePageIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import UIImage from 'UIComponents/image/UIImage';
import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { SPLASH_PAGE_CARD } from '../../constants/tracking/Locations';
import I18n from 'I18n';
const PrimaryTextContainer = styled.div.withConfig({
  displayName: "SplashPageCard__PrimaryTextContainer",
  componentId: "sc-1wiy4v0-0"
})(["display:flex;align-items:center;white-space:nowrap;> h3{font-weight:normal;font-size:1.25rem;margin:0;}"]);
const Link = styled(UIRouterLink).withConfig({
  displayName: "SplashPageCard__Link",
  componentId: "sc-1wiy4v0-1"
})([":hover{text-decoration:none;}"]);
const LinkMessage = styled(FormattedMessage).withConfig({
  displayName: "SplashPageCard__LinkMessage",
  componentId: "sc-1wiy4v0-2"
})([":hover{text-decoration:underline !important;}"]);

const SplashPageCard = ({
  titleKey,
  descriptionKey,
  pathname,
  productLine,
  showIcon = true,
  trackingSource
}) => {
  const handleExploreClick = () => {
    getUsageTracker().track('internalLinkClick', {
      name: 'explore-link',
      url: pathname,
      trackingSource: trackingSource || SPLASH_PAGE_CARD
    });
    window.scrollTo(0, 0);
  };

  return /*#__PURE__*/_jsxs(UICardWrapper, {
    className: "justify-between",
    children: [/*#__PURE__*/_jsx(UICardSection, {
      className: "p-x-6 p-top-8 p-bottom-3",
      children: /*#__PURE__*/_jsxs(PrimaryTextContainer, {
        children: [showIcon && productLine && /*#__PURE__*/_jsx(UIImage, {
          className: "display-inline m-right-3",
          src: ProductLinePageIcons[productLine]
        }), /*#__PURE__*/_jsx("h3", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: titleKey
          })
        })]
      })
    }), /*#__PURE__*/_jsx(UICardSection, {
      className: "p-bottom-0 p-x-6",
      scrollable: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: descriptionKey
      })
    }), /*#__PURE__*/_jsx(UICardSection, {
      className: "p-top-4 p-x-6",
      children: /*#__PURE__*/_jsx(Link, {
        to: createToObject(pathname),
        onClick: handleExploreClick,
        "aria-label": I18n.text('splash-page.exploreProduct', {
          product: I18n.text(titleKey)
        }),
        children: /*#__PURE__*/_jsxs(UIFlex, {
          children: [/*#__PURE__*/_jsx(LinkMessage, {
            message: "splash-page.explore"
          }), /*#__PURE__*/_jsx(UIIcon, {
            name: "next",
            size: "xxs",
            className: "p-left-2"
          })]
        })
      })
    })]
  });
};

export default SplashPageCard;